export default [
    {
        header: 'Activation',
        items: [
            {
                url: "/crm/campaigns",
                name: "Campaigns",
                slug: "crm-campaigns",
                disabled: false,
                permission: "vp.crm.campaigns.view",
                icon: "LayersIcon",
            },
            {
                url: "/crm/automations",
                name: "Automations",
                slug: "crm-automations",
                permission: "vp.crm.automations.view",
                icon: "HardDriveIcon",
            },
            {
                url: "/crm/dynamicforms",
                name: "Dynamic forms",
                slug: "crm-dynamicforms",
                permission: "vp.crm.dynamicforms.view",
                icon: "CodeIcon",
            },
            {
                url: "/crm/guests",
                name: "Guest profiles",
                slug: "crm-guest-profiles",
                permission: "vp.crm.guestprofiles.view",
                icon: "UsersIcon",
            },
            {
                url: "/crm/legaldocuments",
                name: "Compliance",
                slug: "crm-legaldocuments",
                permission: "vp.crm.legaldocuments.view",
                icon: "LinkIcon",
            },
            {
                url: "/crm/medialibrary",
                name: "Media Library",
                slug: "crm-media-library",
                permission: null,
                disabled: true,
                icon: "ImageIcon",
            },
        ]
    },
    {
        header: 'Engage',
        items: [
            {
                url: "/crm/engage/messenger",
                name: "Messenger",
                tag: 'new',
                tagColor: 'primary',
                slug: "crm-engage-messenger",
                permission: "vp.crm.engagemessenger.view",
                disabled: false,
                icon: "MessageSquareIcon",
            },
            {
                url: "/crm/engage/email",
                name: "E-mail",
                tag: 'new',
                tagColor: 'primary',
                slug: "crm-engage-email",
                permission: "vp.crm.engageemail.view",
                disabled: false,
                icon: "MailIcon",
            },
            {
                url: "/crm/engage/configuration",
                name: "Configuration",
                slug: "crm-engage-configuration",
                permission: "vp.crm.engageconfiguration.view",
                disabled: false,
                icon: "SettingsIcon",
            },
        ]
    },
    {
        header: 'Booking',
        items: [
            {
                url: "/marcom/guest-relations",
                name: "Booking overview",
                slug: "guest-relations",
                permission: "vp.crm.bookingoverview.show",
                icon: "CalendarIcon",
            },
        ]
    },



]